/* Pawcket theme — interactions */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function formatMoney(cents, format) {
    format = format || window.shopMoneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Math.round(Number(cents) || 0);
    function withDelims(n, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      var num = (n / 100).toFixed(precision).split('.');
      var dollars = num[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (num[1] ? decimal + num[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0);
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        default: return withDelims(cents, 2);
      }
    });
  }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function addBusinessDays(date, days) {
    var d = new Date(date);
    while (days > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) days--; }
    return d;
  }
  function fmtDate(d) { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); }

  /* ---------- countdown (only for a real, future end date) ---------- */
  customElements.define('countdown-timer', class extends HTMLElement {
    connectedCallback() {
      var end = new Date(this.dataset.end);
      if (isNaN(end) || end <= new Date()) { this.remove(); return; }
      this.hidden = false;
      var el = this, d = this.querySelector('[data-d]'), h = this.querySelector('[data-h]'),
        m = this.querySelector('[data-m]'), s = this.querySelector('[data-s]');
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var diff = Math.max(0, end - new Date());
        if (diff === 0) { el.remove(); clearInterval(t); return; }
        d.textContent = pad(Math.floor(diff / 864e5));
        h.textContent = pad(Math.floor(diff / 36e5) % 24);
        m.textContent = pad(Math.floor(diff / 6e4) % 60);
        s.textContent = pad(Math.floor(diff / 1e3) % 60);
      }
      tick(); var t = setInterval(tick, 1000);
    }
  });

  /* ---------- drawers & modals ---------- */
  function openLayer(el) { if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.body.classList.add('lock'); }
  function closeLayer(el) { if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.drawer.is-open, .modal.is-open')) document.body.classList.remove('lock'); }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      var name = opener.getAttribute('data-drawer-open');
      if (name === 'cart') { renderCart().then(function () { openLayer(document.querySelector('[data-drawer="cart"]')); }); }
      else openLayer(document.querySelector('[data-drawer="' + name + '"]'));
      return;
    }
    var mOpen = e.target.closest('[data-modal-open]');
    if (mOpen) { openLayer(document.querySelector('[data-modal="' + mOpen.getAttribute('data-modal-open') + '"]')); return; }
    if (e.target.closest('[data-drawer-close]')) closeLayer(e.target.closest('.drawer'));
    if (e.target.closest('[data-modal-close]')) closeLayer(e.target.closest('.modal'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.drawer.is-open, .modal.is-open').forEach(closeLayer);
  });

  /* ---------- cart drawer ---------- */
  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
  }
  function renderCart() {
    return fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var body = document.querySelector('[data-cart-body]'), foot = document.querySelector('[data-cart-foot]');
        updateCount(cart.item_count);
        if (!body) return cart;
        if (!cart.items.length) {
          body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
          foot.hidden = true; return cart;
        }
        foot.hidden = false;
        body.innerHTML = '<ul class="cart-lines">' + cart.items.map(function (it, i) {
          var img = it.image ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')) + '" alt="" loading="lazy" width="72" height="72">' : '';
          var variant = it.product_has_only_default_variant ? '' : '<p class="muted">' + esc(it.variant_title) + '</p>';
          var discs = (it.line_level_discount_allocations || []).map(function (d) {
            return '<p class="cart-line__disc">' + esc(d.discount_application.title) + ' (−' + formatMoney(d.amount) + ')</p>';
          }).join('');
          var compare = it.original_line_price > it.final_line_price ? '<s class="muted">' + formatMoney(it.original_line_price) + '</s>' : '';
          return '<li class="cart-line"><a class="cart-line__img" href="' + esc(it.url) + '">' + img + '</a>' +
            '<div class="cart-line__info"><a class="cart-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant + discs +
            '<div class="qty-ctrl"><button type="button" data-qty-change="' + (i + 1) + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease">−</button><span>' + it.quantity +
            '</span><button type="button" data-qty-change="' + (i + 1) + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div></div>' +
            '<div class="cart-line__price">' + compare + '<b>' + formatMoney(it.final_line_price) + '</b></div></li>';
        }).join('') + '</ul>';
        var discWrap = document.querySelector('[data-cart-discounts]');
        if (discWrap) discWrap.innerHTML = (cart.cart_level_discount_applications || []).map(function (d) {
          return '<p class="cart-line__disc">' + esc(d.title) + ' (−' + formatMoney(d.total_allocated_amount) + ')</p>';
        }).join('');
        var total = document.querySelector('[data-cart-total]');
        if (total) total.textContent = formatMoney(cart.total_price);
        return cart;
      });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-change]');
    if (!b) return;
    b.disabled = true;
    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(b.dataset.qtyChange), quantity: Math.max(0, Number(b.dataset.qty)) })
    }).then(renderCart);
  });

  /* ---------- product buy box with bundle tiers ---------- */
  customElements.define('product-buy', class extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('[data-product-json]');
      if (!dataEl) return;
      this.data = JSON.parse(dataEl.textContent);
      this.variants = this.data.variants;
      this.tiers = Array.prototype.slice.call(this.querySelectorAll('[data-tier]'));
      this.firstAvail = this.variants.find(function (v) { return v.available; }) || this.variants[0];
      this.setupGallery();
      this.setupTiers();
      this.setupTimeline();
      this.setupSticky();
      var self = this;
      this.querySelector('[data-atc]').addEventListener('click', function () { self.addToCart(); });
    }

    /* gallery */
    setupGallery() {
      var main = this.querySelector('[data-gallery-main]'); if (!main) return;
      var slides = main.children, thumbs = this.querySelectorAll('[data-thumb-index]');
      this.goTo = function (i) {
        i = (i + slides.length) % slides.length;
        main.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      };
      var current = function () { return Math.round(main.scrollLeft / main.clientWidth); };
      var self = this;
      thumbs.forEach(function (t) { t.addEventListener('click', function () { self.goTo(Number(t.dataset.thumbIndex)); }); });
      var prev = this.querySelector('[data-gallery-prev]'), next = this.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { self.goTo(current() - 1); });
      if (next) next.addEventListener('click', function () { self.goTo(current() + 1); });
      var raf;
      main.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = current();
          thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
          var at = thumbs[i]; if (at) at.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
      });
    }
    showVariantMedia(variant) {
      if (!variant || !variant.featured_media || !this.goTo) return;
      var i = this.data.media.indexOf(variant.featured_media.id);
      if (i > -1) this.goTo(i);
    }

    /* tiers */
    optionSelect(optIndex, selectedValue) {
      var opt = this.data.options[optIndex], values = [];
      this.variants.forEach(function (v) { var val = v.options[optIndex]; if (values.indexOf(val) === -1) values.push(val); });
      return '<select data-opt="' + optIndex + '" aria-label="' + esc(opt) + '">' + values.map(function (val) {
        return '<option value="' + esc(val) + '"' + (val === selectedValue ? ' selected' : '') + '>' + esc(val) + '</option>';
      }).join('') + '</select>';
    }
    buildRows(tier) {
      var wrap = tier.querySelector('[data-tier-variants]'), qty = Number(tier.dataset.qty);
      if (wrap.dataset.built === String(qty)) return;
      var opts = this.data.options, html = '';
      if (opts.length && !(opts.length === 1 && opts[0] === 'Title')) {
        html += '<span class="vrow__label">' + esc(opts.join(' & ')) + '</span>';
        for (var n = 1; n <= qty; n++) {
          html += '<div class="vrow" data-vrow><span class="vrow__n">#' + n + '</span>';
          for (var o = 0; o < Math.min(opts.length, 3); o++) html += this.optionSelect(o, this.firstAvail.options[o]);
          html += '</div>';
        }
        if (opts.length === 1) html = html.replace(/grid-template-columns/g, '');
      }
      wrap.innerHTML = html;
      wrap.dataset.built = String(qty);
      var self = this;
      wrap.querySelectorAll('select').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var v = self.rowVariant(sel.closest('[data-vrow]'));
          self.showVariantMedia(v); self.refresh();
        });
      });
      wrap.querySelectorAll('[data-vrow]').forEach(function (r) { if (opts.length === 1) r.style.gridTemplateColumns = 'auto 1fr'; });
    }
    rowVariant(row) {
      if (!row) return this.firstAvail;
      var vals = Array.prototype.map.call(row.querySelectorAll('select'), function (s) { return s.value; });
      return this.variants.find(function (v) { return vals.every(function (val, i) { return v.options[i] === val; }); });
    }
    selectedTier() { return this.tiers.find(function (t) { return t.querySelector('input').checked; }) || this.tiers[0]; }
    setupTiers() {
      var self = this;
      if (!this.tiers.length) return;
      if (!this.tiers.some(function (t) { return t.querySelector('input').checked; })) this.tiers[0].querySelector('input').checked = true;
      this.tiers.forEach(function (t) {
        self.buildRows(t);
        t.querySelector('input').addEventListener('change', function () { self.refresh(); });
        t.addEventListener('click', function (e) {
          if (e.target.closest('select, option')) return;
          var input = t.querySelector('input');
          if (!input.checked) { input.checked = true; self.refresh(); }
        });
      });
      this.refresh();
    }
    selectedItems() {
      var tier = this.selectedTier(), self = this;
      if (!tier) return [{ variant: this.firstAvail }];
      var rows = tier.querySelectorAll('[data-vrow]');
      if (!rows.length) {
        var out = []; for (var i = 0; i < Number(tier.dataset.qty); i++) out.push({ variant: this.firstAvail }); return out;
      }
      return Array.prototype.map.call(rows, function (r) { return { variant: self.rowVariant(r) }; });
    }
    refresh() {
      var self = this;
      this.tiers.forEach(function (t) {
        t.classList.toggle('is-selected', t.querySelector('input').checked);
        var qty = Number(t.dataset.qty), pct = Number(t.dataset.pct), unit = self.firstAvail.price;
        var rows = t.querySelectorAll('[data-vrow]');
        var full = 0;
        if (rows.length) rows.forEach(function (r) { var v = self.rowVariant(r); full += v ? v.price : unit; });
        else full = unit * qty;
        var total = Math.round(full * (100 - pct) / 100);
        t.querySelector('[data-tier-price]').textContent = formatMoney(total);
        var cmp = t.querySelector('[data-tier-compare]');
        var unitCompare = self.firstAvail.compare_at_price || 0;
        if (pct > 0) cmp.textContent = formatMoney(full);
        else if (unitCompare > unit) cmp.textContent = formatMoney(unitCompare * qty);
        else cmp.textContent = '';
        var save = t.querySelector('[data-tier-save]');
        if (save) save.textContent = 'Save ' + formatMoney(full - total);
      });
      /* availability + low stock for the selected tier */
      var items = this.selectedItems(), btn = this.querySelector('[data-atc]'), label = this.querySelector('[data-atc-label]');
      var bad = items.some(function (it) { return !it.variant || !it.variant.available; });
      btn.disabled = bad;
      label.textContent = bad ? (items.some(function (it) { return !it.variant; }) ? 'Unavailable' : 'Sold out – pick another option') : btn.dataset.label;
      var note = this.querySelector('[data-stock-note]');
      if (note) {
        var low = null, self2 = this;
        items.forEach(function (it) { if (it.variant && self2.data.lowStock[it.variant.id]) low = Math.min(low || 999, self2.data.lowStock[it.variant.id]); });
        note.hidden = !low;
        if (low) note.querySelector('span').textContent = 'Only ' + low + ' left in your selection';
      }
    }
    addToCart() {
      var btn = this.querySelector('[data-atc]'), err = this.querySelector('[data-error]');
      var counts = {};
      this.selectedItems().forEach(function (it) { if (it.variant) counts[it.variant.id] = (counts[it.variant.id] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
      this.querySelectorAll('[data-addon]:checked').forEach(function (a) { items.push({ id: Number(a.value), quantity: 1 }); });
      if (!items.length) return;
      btn.disabled = true; err.hidden = true;
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          btn.disabled = false;
          if (!res.ok) { err.textContent = res.body.description || res.body.message || 'Something went wrong. Please try again.'; err.hidden = false; return; }
          renderCart().then(function () { openLayer(document.querySelector('[data-drawer="cart"]')); });
        })
        .catch(function () { btn.disabled = false; err.textContent = 'Network error. Please try again.'; err.hidden = false; });
    }

    /* delivery timeline from settings */
    setupTimeline() {
      var tl = this.querySelector('[data-timeline]'); if (!tl) return;
      var now = new Date(), ship = addBusinessDays(now, Number(tl.dataset.ship));
      var a = addBusinessDays(ship, Number(tl.dataset.min)), b = addBusinessDays(ship, Number(tl.dataset.max));
      tl.querySelector('[data-t-order]').textContent = fmtDate(now);
      tl.querySelector('[data-t-ship]').textContent = 'by ' + fmtDate(ship);
      tl.querySelector('[data-t-deliver]').textContent = fmtDate(a) + ' – ' + fmtDate(b);
    }

    /* sticky bar */
    setupSticky() {
      var bar = this.querySelector('[data-sticky]'), atc = this.querySelector('[data-atc]');
      if (!bar || !('IntersectionObserver' in window)) return;
      bar.hidden = false;
      var tiers = this.querySelector('[data-tiers]') || atc;
      var past = false;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          past = !en.isIntersecting && en.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', past);
        });
      }).observe(atc);
      bar.querySelector('[data-sticky-buy]').addEventListener('click', function () {
        tiers.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  });

  /* ---------- back to top ---------- */
  var toTop = document.querySelector('[data-to-top]');
  if (toTop) {
    window.addEventListener('scroll', function () { toTop.hidden = window.scrollY < 900; }, { passive: true });
    toTop.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }
})();
